module.exports = __webpack_public_path__ + "img/cart.ea3d1143.png";